import { DefaultLoader } from "./DefaultLoader";
import { FullScreenLoader } from "./FullScreenLoader";
import "./styles.scss";

export interface LoaderProps {
  center?: boolean;
  className?: string;
  message?: string;
  show?: boolean;
  variant?: "default" | "fullscreen";
}

export const Loader = ({
  variant = "default",
  show = true,
  ...rest
}: LoaderProps) => {
  if (!show) return null;
  const Component = variant === "fullscreen" ? FullScreenLoader : DefaultLoader;
  return <Component {...rest} />;
};
